import { compact } from 'lodash/fp';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import { ColumnAlignment } from '@mews/b2b-ui';
import { ActionType, TextKey } from '@mews-commander/enums';
import { TemporalTaskState } from '@mews-commander/legacy-data-structures';
import { oneOf } from '@mews-commander/utils';
import ContextActionMenu from '../../../contextMenu/components/ContextActionMenu';
import { closeTask } from '../../actions';

const TaskContextMenu = ({ close, temporalState, id }: $TSFixMe) => {
    const closeAction = {
        key: 'taskCloseAction',
        onClick: () => close(id),
        icon: IconName.Done,
        text: <LocalizedText textKey={TextKey.Close} />,
        type: ActionType.Link,
        columnAlignment: ColumnAlignment.Right,
    };

    const actions = compact([
        oneOf(temporalState, TemporalTaskState.Pending, TemporalTaskState.Future, TemporalTaskState.Missed) &&
            closeAction,
    ]);

    return <ContextActionMenu actions={actions} />;
};

export default connect(undefined, {
    close: closeTask,
})(TaskContextMenu);
